const WHATSAPP_NUMBER = "5534999901444";
const DEFAULT_MESSAGE = "Olá preciso de uma visita técnica";

export const WHATSAPP_DISPLAY = "(34) 99990-1444";
export const CNPJ = "62.224.825/0001-47";
export const ADDRESS = "Rua Arthur Bernardes, 928 — Uberlândia/MG";
export const HOURS = "Seg–Sex 06h às 18h · Sáb 06h às 12h";

export const buildWaLink = (message = DEFAULT_MESSAGE) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT_LINK = buildWaLink();

export const SECTION_IDS = {
    tipos: "tipos",
    defeitos: "defeitos",
    sobre: "sobre",
};
